/**
 * 会员状态。多个页面都要判断 vip（名人案例的会员条目、会员中心），
 * 集中在这里避免各页各拉一次。
 *
 * 未登录时不发请求 —— membership.get 后端是 requireSignedInOwner，必然失败。
 */
import { useCallback, useEffect, useState } from "react";
import { callApi, getSession } from "../api";

export type Membership = {
  ownerId?: string;
  vip?: boolean;
  plan?: string;
  expiresAt?: string;
};

export function useMembership() {
  const [membership, setMembership] = useState<Membership | null>(null);
  const [loading, setLoading] = useState(false);
  const [signedIn, setSignedIn] = useState(() => Boolean(getSession()));

  const reload = useCallback(async () => {
    if (!getSession()) {
      setSignedIn(false);
      setMembership(null);
      return;
    }
    setSignedIn(true);
    setLoading(true);
    const result = await callApi<{ membership?: Membership }>("membership.get");
    setLoading(false);
    if (result.ok) setMembership(result.membership ?? null);
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { membership, isVip: Boolean(membership?.vip), signedIn, loading, reload };
}
